import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

Vue.use(Vuex)

// const store = new Vuex.Store({
//   state: {
//     count: 0
//   },
  
//   mutations: {
//     increment (state) {
//       state.count++
//     }
//   }
// })

export default new Vuex.Store({
  state: {
  	checkpointLoad: false, // app.vue, quest.vue
    checkPoint: '',
    curSlide: '',
    curQuest: '',
    prevId: '',
    items: [],
    hidden: [],
    mana: 0,
    player: {
            'narrative': 'good',
            'good': 0,
            'evil': 0,
            'lol': 0,
            'adChance': 5
          },

  },
  getters: {

  },
  mutations: {
    checkTrue (state) {
    	state.checkpointLoad = true 
    },

    checkFalse (state) {
    	state.checkpointLoad = false 
    },

    saveCurSlide(state, nextId){
      state.curSlide = nextId
    },

    saveCurQuest(state, newQuest){
      state.curQuest = newQuest
    },

    saveCheckPoint(state, checkPoint){
      state.checkPoint = checkPoint
    },

    savePrevId(state, prevId){
      state.prevId = prevId
    },

    changeNarrative(state, narr){
      state.player.narrative = narr
    },

    addGood(state, point){
      state.player.good = state.player.good + point
    },

    addEvil(state, point){
      state.player.evil = state.player.evil + point
    },

    addLol(state, point){
      state.player.lol = state.player.lol + point
    },

    addChance(state, point){
      state.player.adChance = state.player.adChance + point
    },

    minChance(state, point){
      state.player.adChance = state.player.adChance - point
    },

    addItem(state, item){
      if( !state.items.includes(item)){
        console.log('added ', item )
        state.items.push(item); 
      }
    },

    addHidden(state, item){
      if( !state.hidden.includes(item)){
        console.log('added hidden: ', item )
        state.hidden.push(item); 
      }
    },

    remHidden(state, item){
      if( state.hidden.includes(item)) {
        console.log('StoreJS: Removed hidden: ', item )
        state.hidden.splice(item, 1);
      }
    },

    remItem(state, item){
      if( state.items.includes(item)) {
        console.log('StoreJS: Removed item: ', item )
        state.items.splice(item, 1);
      }
    },

    addMana(state){
      state.mana ++
    },

    Feedback(state){
      state.curSlide = '(System)Feedback'
      location.reload()
    },

    reset(state){
      state.curSlide = ''
      state.player.checkPoint = 0
      state.items = []
      state.hidden = []
      state.player.narrative = 'good'
      state.player.good = 0
      state.player.evil = 0
      state.player.lol = 0
      state.player.adChance = 5
      state.mana = 0
    }

  }, 
  actions: {

  },
  plugins: [new VuexPersistence().plugin]

})

// export default store